import { environment } from '../../../../environments/environment'
import { type CartoClient } from './carto.helper'

export interface TagRow {
  id: number
  name: string
  label: string
  group_name: string
}

export async function fetchTags(
  cartoClient: CartoClient,
  signal?: AbortSignal,
): Promise<TagRow[]> {
  const response = await cartoClient.query<TagRow>({
    source: {
      source: `${environment.CARTO_SOURCE_PREFIX}_tags`,
    },
    params: {
      column: ['id', 'name', 'label', 'group_name'],
    },
    signal,
  })

  return response?.rows ?? []
}
